import i18n from '~/locales/i18n'

export const InventoryCatalog = {
  Catalog: 'catalog',
  OnHand: 'on_hand',
  Shipments: 'shipments',
  Orders: 'orders',
  Adjustments: 'adjustments',
}

export const InventoryCatalogNames = {
  [InventoryCatalog.Catalog]: i18n.t('Common:CATALOG'),
  [InventoryCatalog.OnHand]: i18n.t('Common:ON-HAND'),
  [InventoryCatalog.Shipments]: i18n.t('Common:ORDERS_MANUAL'),
  [InventoryCatalog.Orders]: i18n.t('Common:ORDERS'),
  [InventoryCatalog.Adjustments]: i18n.t('Common:ADJUSTMENTS'),
}

export const getAvailableCatalogList = (
  isEnhancedInventoryReceivingEnabled: boolean,
) => {
  const { Catalog, OnHand, Orders, Shipments, Adjustments } = InventoryCatalog

  const tabOrder = [Catalog, OnHand, Orders, Shipments, Adjustments]
  const legacyTabOrder = [Catalog, OnHand, Shipments, Adjustments]
  const catalogOrder = isEnhancedInventoryReceivingEnabled
    ? tabOrder
    : legacyTabOrder // This order can be removed once the toggle is deleted

  const getCatalogLabel = (catalog: string): string => {
    // The condition can be removed once the toggle is deleted
    if (catalog === InventoryCatalog.Shipments) {
      return isEnhancedInventoryReceivingEnabled
        ? i18n.t('Common:ORDERS_MANUAL')
        : i18n.t('Common:SHIPMENTS')
    }
    return InventoryCatalogNames[catalog]
  }

  return catalogOrder.map((value) => ({
    label: getCatalogLabel(value),
    value,
  }))
}
